'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useNavCategoryItemContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useNavCategoryItemContextValues_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useNavCategoryItemContextValues_unstable(state) {
    const { open, value } = state;
    const navCategoryItem = _react.useMemo(()=>({
            open,
            value
        }), [
        open,
        value
    ]);
    return {
        navCategoryItem
    };
}
